import { useState } from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { download } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useApi, PageHeader, Loading, Empty, Select, TableWrap, KpiCard } from "../components/common";
import { Button } from "../components/ui/button";
import { fdate, inr } from "../lib/format";

export default function Payments() {
  const { meta } = useAuth();
  const [flt, setFlt] = useState({ q: "", method: "", start: "", end: "", include_voided: false });
  const qs = new URLSearchParams(Object.fromEntries(Object.entries(flt).filter(([, v]) => v))).toString();
  const { data, loading } = useApi(`/payments?${qs}`);
  const s = (k) => (v) => setFlt({ ...flt, [k]: v?.target ? (v.target.type === "checkbox" ? v.target.checked : v.target.value) : v });
  return (
    <div>
      <PageHeader title="Payment Register" subtitle="Record payments from an invoice. Manually recorded entries — no bank or gateway verification is connected."
        actions={<Button variant="outline" onClick={() => download("/export/payments", "payments.csv")} data-testid="payment-export-button"><Download className="h-4 w-4 mr-1" />Export</Button>} />
      {data && <div className="grid grid-cols-3 gap-3 mb-4">
        <KpiCard testid="payments-received" label="Received" value={inr(data.totals.received)} tone="cash" />
        <KpiCard testid="payments-refunded" label="Refunded" value={inr(data.totals.refunded)} tone="expense" />
        <KpiCard testid="payments-net" label="Net Collected" value={inr(data.totals.net)} tone="profit" /></div>}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2 mb-4">
        <input data-testid="payment-filter-search" className="vmw-input col-span-2" placeholder="Search ID, client, invoice, reference…" value={flt.q} onChange={s("q")} />
        <Select testid="payment-filter-method" placeholder="All methods" options={meta?.payment_methods || []} value={flt.method} onChange={s("method")} />
        <input type="date" className="vmw-input" value={flt.start} onChange={s("start")} data-testid="payment-filter-start" />
        <input type="date" className="vmw-input" value={flt.end} onChange={s("end")} data-testid="payment-filter-end" />
      </div>
      <TableWrap>
        {loading && !data ? <Loading /> : !data?.items.length ? <Empty text="No payments" /> : (
          <table className="vmw-table" data-testid="payments-table">
            <thead><tr><th>Payment</th><th>Date</th><th>Invoice</th><th>Client</th><th>Project</th><th>Type</th><th>Method</th><th>Reference</th><th className="text-right">Amount</th><th>Recorded By</th></tr></thead>
            <tbody>{data.items.map((p) => (
              <tr key={p.id} data-testid={`payment-row-${p.id}`} className={p.voided ? "opacity-50" : ""}>
                <td className="font-mono text-xs">{p.code}</td><td>{fdate(p.date)}</td>
                <td><Link to={`/invoices/${p.invoice_id}`} className="font-mono text-xs text-primary font-semibold">{p.invoice_number}</Link></td>
                <td>{p.client_name}</td><td className="text-xs">{p.project_name}</td><td className="capitalize">{p.kind}</td><td>{p.method}</td><td className="text-xs">{p.reference || "—"}</td>
                <td className={`text-right font-num font-semibold ${p.kind === "refund" ? "text-rose-600" : "text-emerald-700"}`}>{p.kind === "refund" ? "−" : ""}{inr(p.amount, true)}</td><td className="text-xs">{p.recorded_by_name}</td>
              </tr>))}</tbody>
          </table>)}
      </TableWrap>
    </div>
  );
}
